import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function ProductsPriceListHeader() { return ( <ContentHeader title='Products Price List' /> ) }

export default React.memo(ProductsPriceListHeader)